var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import _ from 'lodash';
import { checkNumber } from './CommonUtil';
export var mappingLineItem = function (item) {
    var form = {
        id: item.id,
        lineItemId: item.gamLineItem.id,
        lineItemName: item.gamLineItem.displayName,
        inventoryId: item.inventory.id,
        inventoryName: item.inventory.name,
        creativeRotationType: item.gamLineItem.creativeRotationType,
        networkId: item.gamLineItem && item.gamLineItem.gamNetwork ? item.gamLineItem.gamNetwork.id : "",
        network: item.gamLineItem && item.gamLineItem.gamNetwork ? item.gamLineItem.gamNetwork.displayName : "",
        accountId: item.gamLineItem && item.gamLineItem.gamNetwork && item.gamLineItem.gamNetwork.account ? item.gamLineItem.gamNetwork.account.id : "",
        account: item.gamLineItem && item.gamLineItem.gamNetwork && item.gamLineItem.gamNetwork.account ? item.gamLineItem.gamNetwork.account.name : "",
        publisherId: item.inventory && item.inventory.media && item.inventory.media.publisher ? item.inventory.media.publisher.id : "",
        publisher: item.inventory && item.inventory.media && item.inventory.media.publisher ? item.inventory.media.publisher.name : "",
        mode: item.mode,
        lastCalculate: item.lastCalculate ? moment(item.lastCalculat).format("YYYY-MM-DD HH:mm:ss") : "",
        nextCalculate: item.nextCalculate ? moment(item.nextCalculate).format("YYYY-MM-DD HH:mm:ss") : "",
        lastUpdate: item.lastUpdate ? moment(item.lastUpdate).format("YYYY-MM-DD HH:mm:ss") : "",
        frequencyCronExpr: item.frequencyCronExpr,
        coefficient: item.settings && item.settings.coefficient ? item.settings.coefficient : "",
        finalRate: item.resultCalculated && checkNumber(item.resultCalculated.finalRate) ? item.resultCalculated.finalRate : "-",
        cpmP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP1) ? item.resultCalculated.otherInfo.cpmP1 : "-",
        cpmP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP2) ? item.resultCalculated.otherInfo.cpmP2 : "-",
        fillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP1) ? item.resultCalculated.otherInfo.fillRateP1 : "-",
        fillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP2) ? item.resultCalculated.otherInfo.fillRateP2 : "-",
        actualFillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP1) ? item.resultCalculated.otherInfo.actualFillRateP1 : "-",
        actualFillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP2) ? item.resultCalculated.otherInfo.actualFillRateP2 : "-",
        minCPM: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minCPM) ? item.resultCalculated.otherInfo.minCPM : "-",
        minP1Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP1Rate) ? item.resultCalculated.otherInfo.minP1Rate : "-",
        minP2Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP2Rate) ? item.resultCalculated.otherInfo.minP2Rate : "-",
        valueForRef: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.valueForRef) ? item.resultCalculated.otherInfo.valueForRef : "-",
        newRate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.newRate) ? item.resultCalculated.otherInfo.newRate : "-",
        currentRate: item.gamLineItem && checkNumber(item.gamLineItem.currentRate) ? item.gamLineItem.currentRate : "-",
        status: item.status,
        creativeAllocationSettings: item.creativeAllocation && item.creativeAllocation.creativeAllocationSettings ? item.creativeAllocation.creativeAllocationSettings : null,
        appliedCreativeWeight: item.appliedCreativeWeight ? item.appliedCreativeWeight : false,
        earningOptimization: item.settings && item.settings.earningOptimization ? item.settings.earningOptimization : "",
        earningFillrateCalculate: item.settings && item.settings.earningFillrateCalculate ? item.settings.earningFillrateCalculate : {
            type: "DEFAULT_BY_REQUEST"
        },
        activated: item.activated ? true : false
    };
    if (item.gamLineItem.creativeRotationType == "MANUAL") {
        form.creativeRotationType = "WEIGHT";
    }
    return form;
};
export var mappingCalculateForm = function (item, platformGroups) {
    var form = {
        frequencyCronExpr: item.frequencyCronExpr,
        mode: item.mode,
        activated: item.activated ? true : false,
        coefficient: item.settings.coefficient,
        lineItemId: item.gamLineItem.id,
        lineItemName: item.gamLineItem.displayName,
        inventoryId: item.inventory.id,
        inventoryName: item.inventory.name,
        finalRate: item.resultCalculated && checkNumber(item.resultCalculated.finalRate) ? item.resultCalculated.finalRate : "-",
        cpmP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP1) ? item.resultCalculated.otherInfo.cpmP1 : "-",
        cpmP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP2) ? item.resultCalculated.otherInfo.cpmP2 : "-",
        fillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP1) ? item.resultCalculated.otherInfo.fillRateP1 : "-",
        fillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP2) ? item.resultCalculated.otherInfo.fillRateP2 : "-",
        actualFillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP1) ? item.resultCalculated.otherInfo.actualFillRateP1 : "-",
        actualFillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP2) ? item.resultCalculated.otherInfo.actualFillRateP2 : "-",
        minCPM: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minCPM) ? item.resultCalculated.otherInfo.minCPM : "-",
        minP1Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP1Rate) ? item.resultCalculated.otherInfo.minP1Rate : "-",
        minP2Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP2Rate) ? item.resultCalculated.otherInfo.minP2Rate : "-",
        valueForRef: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.valueForRef) ? item.resultCalculated.otherInfo.valueForRef : "-",
        newRate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.newRate) ? item.resultCalculated.otherInfo.newRate : "-",
        currentRate: item.gamLineItem && checkNumber(item.gamLineItem.currentRate) ? item.gamLineItem.currentRate : "-",
    };
    if (item.settings.minimumPlatformGroupId) {
        form.platformGroupMinimumUpdate = (platformGroups || []).find(function (platformGroup) {
            return platformGroup.id == item.settings.minimumPlatformGroupId;
        });
        if (form.platformGroupMinimumUpdate) {
            form.platformGroupMinimumUpdate.subPlatformGroups = (form.platformGroupMinimumUpdate.subPlatformGroups || []).map(function (subPlatformGroup) {
                var foundSubplatformGroup = (item.settings.minimumSubPlatformGroupIds || []).find(function (minimumSubPlatformGroupId) {
                    return minimumSubPlatformGroupId == subPlatformGroup.id;
                });
                if (foundSubplatformGroup) {
                    subPlatformGroup.isSelected = true;
                    if (subPlatformGroup.platformGroupPlatforms) {
                        subPlatformGroup.platformGroupPlatforms = (subPlatformGroup.platformGroupPlatforms || []).map(function (platformGroupPlatform) {
                            var foundPlatform = (item.settings.minimumPlatformIds || []).find(function (minimumPlatformId) {
                                return minimumPlatformId == platformGroupPlatform.platformId;
                            });
                            if (foundPlatform) {
                                platformGroupPlatform.isSelected = true;
                            }
                            else {
                                platformGroupPlatform.isSelected = false;
                            }
                            return platformGroupPlatform;
                        });
                    }
                }
                else {
                    subPlatformGroup.isSelected = false;
                }
                return subPlatformGroup;
            });
        }
    }
    return form;
};
var mappingLineItemCreativeAllocation = function (creativeTmp, data, platformGroups) {
    var form = {
        allocationExternalLineItemId: creativeTmp.externalLineItemId,
        allocationExternalCreativeName: creativeTmp.externalCreativeName,
        allocationExternalCreativeId: creativeTmp.externalCreativeId,
        allocationCurrentWeight: creativeTmp.externalCurrentWeight,
        allocationMode: "",
        allocationFixedPercent: null,
        allocationPlatformGroupId: "",
        allocationSubPlatformGroupIds: [],
        allocationPlatformIds: [],
        tmpForm: {
            platformGroupOptions: _.cloneDeep(platformGroups),
            subPlatformGroupOptions: [],
            externalCreativeName: creativeTmp.externalCreativeName,
            allocationCPMValue: "",
            allocationWeightValueToUpdate: "",
            allocationPlatformGroupName: ""
        }
    };
    if (data) {
        form.allocationPlatformGroupId = data.allocationPlatformGroupId;
        form.allocationSubPlatformGroupIds = data.allocationSubPlatformGroupIds;
        form.allocationPlatformIds = data.allocationPlatformIds;
        form.tmpForm.allocationCPMValue = data.allocationCPMValue || "";
        form.tmpForm.allocationWeightValueToUpdate = data.allocationWeightValueToUpdate;
        // if (data.allocationCurrentWeight) {
        //     form.allocationCurrentWeight = data.allocationCurrentWeight;
        // }
        if (data.allocationMode != "AUTO") {
            form.allocationMode = "FIXED";
            if (typeof (data.allocationFixedPercent) == "number") {
                form.allocationFixedPercent = data.allocationFixedPercent;
            }
            else {
                form.allocationFixedPercent = 0;
            }
        }
        else {
            form.allocationMode = "AUTO";
        }
    }
    else {
        if (platformGroups && platformGroups.length) {
            form.allocationPlatformGroupId = platformGroups[0].id;
        }
        form.allocationMode = "AUTO";
    }
    if (form.allocationPlatformGroupId) {
        var platformGroupsUpdate = (form.tmpForm.platformGroupOptions || []).find(function (platformGroup) {
            return platformGroup.id == form.allocationPlatformGroupId;
        });
        if (platformGroupsUpdate) {
            form.tmpForm.allocationPlatformGroupName = platformGroupsUpdate.name;
            form.tmpForm.subPlatformGroupOptions = (platformGroupsUpdate.subPlatformGroups || []).map(function (subPlatformGroup) {
                var foundSubplatformGroup = (form.allocationSubPlatformGroupIds || []).find(function (minimumSubPlatformGroupId) {
                    return minimumSubPlatformGroupId == subPlatformGroup.id;
                });
                if (foundSubplatformGroup) {
                    subPlatformGroup.isSelected = true;
                    if (subPlatformGroup.platformGroupPlatforms) {
                        subPlatformGroup.platformGroupPlatforms = (subPlatformGroup.platformGroupPlatforms || []).map(function (platformGroupPlatform) {
                            var foundPlatform = (form.allocationPlatformIds || []).find(function (minimumPlatformId) {
                                return minimumPlatformId == platformGroupPlatform.platformId;
                            });
                            if (foundPlatform) {
                                platformGroupPlatform.isSelected = true;
                            }
                            else {
                                platformGroupPlatform.isSelected = false;
                            }
                            return platformGroupPlatform;
                        });
                    }
                }
                else {
                    subPlatformGroup.isSelected = false;
                }
                return subPlatformGroup;
            });
        }
    }
    return form;
};
export var mappingCreativeAllocation = function (dataLineItem, allocationSettingTmp, platformGroups) {
    var form = {
        allocationNumOfDays: 7,
        allocationDistanceToEnd: 0,
        creativeAllocationItems: []
    };
    if (dataLineItem && dataLineItem.creativeAllocation) {
        form.allocationNumOfDays = dataLineItem.creativeAllocation.allocationNumOfDays;
        form.allocationDistanceToEnd = dataLineItem.creativeAllocation.allocationDistanceToEnd;
    }
    form.creativeAllocationItems = allocationSettingTmp.map(function (creativeAllocation) {
        if (dataLineItem && dataLineItem.creativeAllocation && dataLineItem.creativeAllocation.creativeAllocationSettings) {
            var foundCreative = dataLineItem.creativeAllocation.creativeAllocationSettings.find(function (creativeAllocationSetting) {
                return creativeAllocation.externalCreativeId == creativeAllocationSetting.allocationExternalCreativeId;
            });
            return mappingLineItemCreativeAllocation(creativeAllocation, foundCreative, platformGroups);
        }
        else {
            return mappingLineItemCreativeAllocation(creativeAllocation, null, platformGroups);
        }
    });
    return form;
};
export var mappingLineItemCreativeAllocationAdd = function (lineItems, lineItemCreatives, platformGroups) {
    var data = lineItems.map(function (item) {
        var form = {
            lineItemId: item.lineItem.id,
            lineItemName: item.lineItem.displayName,
            externalLineItemId: item.lineItem.externalLineItemId,
            inventoryId: item.inventory.id,
            creativeRotationType: item.lineItem.creativeRotationType,
            creativeAllocation: []
        };
        if (form.creativeRotationType == "MANUAL") {
            form.creativeRotationType = "WEIGHT";
        }
        var listCreativeForLineItem = lineItemCreatives.filter(function (lineItemCreative) {
            return lineItemCreative.externalLineItemId == item.lineItem.externalLineItemId;
        });
        if (listCreativeForLineItem && listCreativeForLineItem.length) {
            form.creativeAllocation = mappingCreativeAllocation(null, listCreativeForLineItem, platformGroups);
        }
        return form;
    });
    return data;
};
export var getDataLineItems = function (item, val) {
    var form = {
        id: item.id,
        lineItemId: item.gamLineItem.id,
        lineItemName: item.gamLineItem.displayName,
        inventoryId: item.inventory.id,
        inventoryName: item.inventory.name,
        creativeRotationType: item.gamLineItem.creativeRotationType,
        networkId: item.gamLineItem && item.gamLineItem.gamNetwork ? item.gamLineItem.gamNetwork.id : "",
        network: item.gamLineItem && item.gamLineItem.gamNetwork ? item.gamLineItem.gamNetwork.displayName : "",
        accountId: item.gamLineItem && item.gamLineItem.gamNetwork && item.gamLineItem.gamNetwork.account ? item.gamLineItem.gamNetwork.account.id : "",
        account: item.gamLineItem && item.gamLineItem.gamNetwork && item.gamLineItem.gamNetwork.account ? item.gamLineItem.gamNetwork.account.name : "",
        publisherId: item.inventory && item.inventory.media && item.inventory.media.publisher ? item.inventory.media.publisher.id : "",
        publisher: item.inventory && item.inventory.media && item.inventory.media.publisher ? item.inventory.media.publisher.name : "",
        mode: item.mode,
        lastCalculate: item.lastCalculate ? moment(item.lastCalculat).format("YYYY-MM-DD HH:mm:ss") : "",
        nextCalculate: item.nextCalculate ? moment(item.nextCalculate).format("YYYY-MM-DD HH:mm:ss") : "",
        lastUpdate: item.lastUpdate ? moment(item.lastUpdate).format("YYYY-MM-DD HH:mm:ss") : "",
        frequencyCronExpr: item.frequencyCronExpr,
        coefficient: item.settings && item.settings.coefficient ? item.settings.coefficient : "",
        finalRate: item.resultCalculated && checkNumber(item.resultCalculated.finalRate) ? item.resultCalculated.finalRate : "-",
        cpmP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP1) ? item.resultCalculated.otherInfo.cpmP1 : "-",
        cpmP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.cpmP2) ? item.resultCalculated.otherInfo.cpmP2 : "-",
        fillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP1) ? item.resultCalculated.otherInfo.fillRateP1 : "-",
        fillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.fillRateP2) ? item.resultCalculated.otherInfo.fillRateP2 : "-",
        actualFillRateP1: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP1) ? item.resultCalculated.otherInfo.actualFillRateP1 : "-",
        actualFillRateP2: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.actualFillRateP2) ? item.resultCalculated.otherInfo.actualFillRateP2 : "-",
        minCPM: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minCPM) ? item.resultCalculated.otherInfo.minCPM : "-",
        minP1Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP1Rate) ? item.resultCalculated.otherInfo.minP1Rate : "-",
        minP2Rate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.minP2Rate) ? item.resultCalculated.otherInfo.minP2Rate : "-",
        valueForRef: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.valueForRef) ? item.resultCalculated.otherInfo.valueForRef : "-",
        newRate: item.resultCalculated && item.resultCalculated.otherInfo && checkNumber(item.resultCalculated.otherInfo.newRate) ? item.resultCalculated.otherInfo.newRate : "-",
        currentRate: item.gamLineItem && checkNumber(item.gamLineItem.currentRate) ? item.gamLineItem.currentRate : "-",
        status: item.status,
        creativeAllocationSettings: item.creativeAllocation && item.creativeAllocation.creativeAllocationSettings ? item.creativeAllocation.creativeAllocationSettings : null,
        appliedCreativeWeight: item.appliedCreativeWeight ? item.appliedCreativeWeight : false,
        earningOptimization: item.settings && item.settings.earningOptimization ? item.settings.earningOptimization : "",
        earningFillrateCalculate: item.settings && item.settings.earningFillrateCalculate ? item.settings.earningFillrateCalculate : {
            type: "DEFAULT_BY_REQUEST"
        },
        activated: item.activated ? true : false
    };
    if (item.gamLineItem.creativeRotationType == "MANUAL") {
        form.creativeRotationType = "WEIGHT";
    }
    // if (typeof(val) !== 'undefined') {
    //     angular.extend(form, val);
    // }
    return form;
};
export var editFloorPricingRule = function (item) {
    var form = {
        mode: item.mode ? item.mode : "HYBRID",
        activated: item.activated ? true : false,
        frequencyDate: item.frequencyDate ? parseInt(item.frequencyDate) : 3,
        frequencyTime: item.frequencyTime ? item.frequencyTime : ""
    };
    if (item.settings && item.settings.coefficient) {
        form = __assign(__assign({}, form), { coefficient: item.settings.coefficient, period1Start: item.settings.period1Start, period1End: item.settings.period1End, period2Start: item.settings.period2Start, period2End: item.settings.period2End, periodCompare1NumOfDays: item.settings.periodCompare1NumOfDays, periodCompare1DistanceToEnd: item.settings.periodCompare1DistanceToEnd, periodCompare2NumOfDays: item.settings.periodCompare2NumOfDays, periodCompare2DistanceToEnd: item.settings.periodCompare2DistanceToEnd, earningOptimization: item.settings.earningOptimization ? item.settings.earningOptimization : {
                mode: "FILLRATE"
            }, earningFillrateCalculate: item.settings.earningFillrateCalculate ? item.settings.earningFillrateCalculate : {
                type: "DEFAULT_BY_REQUEST"
            } });
    }
    else {
        form = __assign(__assign({}, form), { coefficient: "", period1Start: "", period1End: "", period2Start: "", period2End: "", periodCompare1NumOfDays: "", periodCompare1DistanceToEnd: "", periodCompare2NumOfDays: "", periodCompare2DistanceToEnd: "", earningOptimization: {
                mode: "FILLRATE"
            }, earningFillrateCalculate: {
                type: "DEFAULT_BY_REQUEST"
            } });
    }
    return form;
};
export var settupPlatformGroup = function (item, platformGroups) {
    var form = {};
    if (item.settings.minimumPlatformGroupId) {
        var platformGroupsMinimum = _.cloneDeep(platformGroups);
        form.platformGroupMinimumFloor = item.settings.minimumPlatformGroupId;
        var platformGroupMinimumUpdate = (platformGroupsMinimum || []).find(function (platformGroup) {
            return platformGroup.id == item.settings.minimumPlatformGroupId;
        });
        if (platformGroupMinimumUpdate) {
            form.subPlatformGroupMinimumOptions = (platformGroupMinimumUpdate.subPlatformGroups || []).map(function (subPlatformGroup) {
                var foundSubplatformGroup = (item.settings.minimumSubPlatformGroupIds || []).find(function (minimumSubPlatformGroupId) {
                    return minimumSubPlatformGroupId == subPlatformGroup.id;
                });
                if (foundSubplatformGroup) {
                    subPlatformGroup.isSelected = true;
                    if (subPlatformGroup.platformGroupPlatforms) {
                        subPlatformGroup.platformGroupPlatforms = (subPlatformGroup.platformGroupPlatforms || []).map(function (platformGroupPlatform) {
                            var foundPlatform = (item.settings.minimumPlatformIds || []).find(function (minimumPlatformId) {
                                return minimumPlatformId == platformGroupPlatform.platformId;
                            });
                            if (foundPlatform) {
                                platformGroupPlatform.isSelected = true;
                            }
                            else {
                                platformGroupPlatform.isSelected = false;
                            }
                            return platformGroupPlatform;
                        });
                    }
                }
                else {
                    subPlatformGroup.isSelected = false;
                }
                return subPlatformGroup;
            });
        }
    }
    if (item.settings.earningPlatformGroupId) {
        var platformGroupsEarning = _.cloneDeep(platformGroups);
        form.platformGroupEarnings = item.settings.earningPlatformGroupId;
        var platformGroupEarningUpdate = (platformGroupsEarning || []).find(function (platformGroup) {
            return platformGroup.id == item.settings.earningPlatformGroupId;
        });
        if (platformGroupEarningUpdate) {
            form.subPlatformGroupEarningOptions = (platformGroupEarningUpdate.subPlatformGroups || []).map(function (subPlatformGroup) {
                var foundSubplatformGroup = (item.settings.earningSubPlatformGroupIds || []).find(function (minimumSubPlatformGroupId) {
                    return minimumSubPlatformGroupId == subPlatformGroup.id;
                });
                if (foundSubplatformGroup) {
                    subPlatformGroup.isSelected = true;
                    if (subPlatformGroup.platformGroupPlatforms) {
                        subPlatformGroup.platformGroupPlatforms = (subPlatformGroup.platformGroupPlatforms || []).map(function (platformGroupPlatform) {
                            var foundPlatform = (item.settings.earningPlatformIds || []).find(function (minimumPlatformId) {
                                return minimumPlatformId == platformGroupPlatform.platformId;
                            });
                            if (foundPlatform) {
                                platformGroupPlatform.isSelected = true;
                            }
                            else {
                                platformGroupPlatform.isSelected = false;
                            }
                            return platformGroupPlatform;
                        });
                    }
                }
                else {
                    subPlatformGroup.isSelected = false;
                }
                return subPlatformGroup;
            });
        }
    }
    return form;
};
